import React from 'react';
import PropTypes from 'prop-types';
import LazyImage from './LazyImage';

const CarouselImage = ({ image, enableLightbox, toggleModal, handleSelectedImage, priority }) => {
  const { url: imageUrl = '', data: imageData } = image || {};
  const { altText } = imageData || {}

  const handleEnableLightbox = () => {
    if (!enableLightbox) return;
    toggleModal();
    handleSelectedImage(image.id);
  };

  return (
    <div className="carousel__slide">
      <LazyImage
          src={imageUrl}
          alt={altText}
          sizeKey="carousel:centered"
          onClick={handleEnableLightbox}
          role="button"
          priority={priority}
        />
    </div>
  );
};

CarouselImage.propTypes = {
  image: PropTypes.object.isRequired,
  enableLightbox: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleSelectedImage: PropTypes.func.isRequired,
  priority: PropTypes.bool.isRequired
};

export default CarouselImage;
